import React, {useState, useEffect} from 'react'
import Cookies from 'universal-cookie';
import cards from './cards.json';
import './style.css';

var cardId = Math.floor((Math.random() * cards.length))
var staple = cards[cardId]["staple"]

const cookies = new Cookies();
if(!cookies.get('highScore'))
cookies.set('highScore', 0, {expires: new Date(Date.now()+86400*365), path: '/'})

export default function App() {
  const [score, setScore] = useState(0);
  const [cardName, setCardName] = useState(cards[cardId]["name"]);
  const [cardImages, setCardImg] = useState(cards[cardId]["img"]);
  const [cardRotation, setCardRotation] = useState({transform: "rotateX(-10deg) rotateY(0deg)"});
  const [mousePos, setMousePos] = useState({});
  const [highScore, setHighScore] = useState(cookies.get('highScore'));
  const [playing, play] = useState(false);
  useEffect(() => {
    const keyDownHandler = event => {
      if(event.key==="ArrowRight")
      guess(false)
      else if(event.key==="ArrowLeft")
      guess(true)
    }

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  });

  useEffect(() => {
    const handleMouseMove = (event) => {
      setMousePos({
        x: event.target.width-(event.clientX-event.target.offsetLeft)/10,
        y: (event.clientY-event.target.offsetTop)/20
      })
    }

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove',handleMouseMove);
    };
  }, []);

  function rotateImage(){
    setCardRotation({transform: "rotateX("+(mousePos.y)+"deg) rotateY("+mousePos.x+"deg)"})
  }
  function resetImage(){
    setCardRotation({transform: "rotateX(-10deg) rotateY(0deg)"})
  }

  function guess(input){
    if(input === staple)
    {
      setScore(score + 1)
    }
    else
    {
      if(score>cookies.get('highScore'))
      {
        cookies.set('highScore', score, {expires: new Date(Date.now()+86400*365), path: '/'})
        setHighScore(score)
      }
      setScore(0)
      play(false)
    }
    cardId = Math.floor((Math.random() * cards.length))
    setCardName(cards[cardId]["name"])
    setCardImg(cards[cardId]["img"])
    staple = cards[cardId]["staple"]
  }
  if(playing)
  return (
    <>
    <img style={cardRotation} onMouseLeave={() => resetImage()} onMouseMove={() => rotateImage()} src={cardImages[0]}></img>
    <div>{cardName}</div>
    <button class="staple guess" onClick={() => guess(true)}>
        Staple
    </button>
    <button class="stinker guess" onClick={() => guess(false)}>
        Stinker
    </button>
    <text class="score">Score: {score}</text>
    <text class="highScore">HighScore: {highScore}</text>
    </>
  )
  else return (
    <>
    <div class="container" onClick={() => play(true)}>
      <div class="title"><text class="green">Staple</text><text> or </text><text class="red">Stinker</text></div>
      <br></br>
      <div class="rotation">Tap anywhere to play</div>
      <text class="inspiration">Inspired by <a href="https://www.youtube.com/@Rarran">Rarran</a></text>
      <text class="highScore">HighScore: {highScore}</text>
    </div>
    </>
  )
}